__turbopack_context__.v({
  "className": "caveat_edbedb17-module__S2TVvq__className",
});
